import { Injectable } from "@angular/core";
import { AccountDTO } from "../accounts/Account";
import { ApiService } from "../api.service";

const PATH = "accounts";

@Injectable({
  providedIn: "root",
})
export class AccountHandlerService {
  constructor(private ApiService: ApiService) {}

  getAccount(
    masterAccountID: number,
    accountID: number,
    ignoreAccountUsers = false,
  ) {
    return this.ApiService.get(
      `${PATH}/${masterAccountID}/${accountID}${
        ignoreAccountUsers ? "?ignoreAccountUsers=true" : ""
      }`,
    );
  }

  deleteAccount(
    masterAccountID: number,
    accountID: number,
    ignoreAccountUsers = false,
  ) {
    return this.ApiService.delete(
      `${PATH}/${masterAccountID}/${accountID}${
        ignoreAccountUsers ? "?ignoreAccountUsers=true" : ""
      }`,
    );
  }

  getAccounts(
    masterAccountID: number,
    queryParams?: {
      facility_id?: number[];
      start?: string;
      end?: string;
      page?: number;
      perPage?: number;
      ignoreAccountUsers?: boolean;
    },
  ) {
    return this.ApiService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  putAccount(
    masterAccountID: number,
    accountDTO: AccountDTO,
    ignoreAccountUsers = false,
  ) {
    return this.ApiService.put(
      `${PATH}/${masterAccountID}/${accountDTO.id}${
        ignoreAccountUsers ? "?ignoreAccountUsers=true" : ""
      }`,
      accountDTO,
    );
  }

  putAccountCatalog(masterAccountID: number, accountDTO: AccountDTO) {
    return this.ApiService.put(
      `${PATH}/${masterAccountID}/${accountDTO.id}/catalog`,
      accountDTO,
    );
  }

  postAccount(masterAccountID: number, accountDTO: AccountDTO) {
    return this.ApiService.post(`${PATH}/${masterAccountID}`, accountDTO);
  }

  getStripeSession(masterAccountID: number, stripeId: string) {
    return this.ApiService.get(`${PATH}/${masterAccountID}/${masterAccountID}/stripe_session/${stripeId}`);
  }

  postStripeCustomer(accountID: number, stripeID: string, stripeName: string) {
    return this.ApiService.post(`${PATH}/${accountID}/${accountID}/stripe_customer`, {
      stripe_id: stripeID,
      stripe_name: stripeName
    })
  }

  deleteStripeCustomer(accountId: number, id: number) {
    return this.ApiService.delete(`${PATH}/${accountId}/${accountId}/stripe_customer/${id}`)
  }

}
